import { AiOutlineClear } from "react-icons/ai";
import { TbMessage } from "react-icons/tb";
import { IoSettings } from "react-icons/io5";
import { GrAnnounce } from "react-icons/gr";
import {
  openCache,
  openLanguagePop,
} from "../../redux/action/member/memberAction";
import { MdOutlineLanguage } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import {
  PiChartLineUpBold,
  PiSpeakerSimpleHighFill,
  PiSpeakerSimpleXFill,
} from "react-icons/pi";
import { useTranslation } from "react-i18next";
import { WEB_LAYOUT } from "../../constant";
import { toggleBGM } from "../../redux/action/action";
import { TiHeartFullOutline } from "react-icons/ti";
import { useSearchParams } from "react-router-dom";

const isCredit = process.env.REACT_APP_CREDIT === "1";

export const useMenuConfig = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const [_searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const isBGMEnabled = useSelector((state) => state.isBGMEnabled);
  const { enabled } = isBGMEnabled || {};

  const menu = {
    more: [
      {
        icon: PiChartLineUpBold,
        text: i18n("rebate"),
        link: "my-rebate",
        iconColor: "#963EFF",
        auth: true,
        hidden: isCredit,
      },
      {
        icon: TbMessage,
        text: i18n("inbox"),
        link: "inbox",
        iconColor: "#D6DDFF",
        iconTextColor: "#537CFF",
        auth: true,
      },
      {
        icon: TiHeartFullOutline,
        text: i18n("MyFavorite"),
        link: "data",
        iconColor: "#D6DDFF",
        iconTextColor: "#537CFF",
        auth: true,
      },
    ],
    basic: [
      {
        icon: IoSettings,
        text: i18n("settings"),
        link: "settings",
        iconColor: "#88919A",
        auth: true,
      },

      {
        icon: MdOutlineLanguage,
        text: i18n("language"),
        link: "language",
        func: () => {
          dispatch(openLanguagePop());
        },
        border: true,
        iconColor: "#88919A",
      },
      {
        icon: AiOutlineClear,
        text: i18n("clearcache"),
        link: "clear-cache",
        func: () => {
          dispatch(openCache());
        },
        iconColor: "#88919A",
      },
      {
        icon: enabled ? PiSpeakerSimpleXFill : PiSpeakerSimpleHighFill,
        text: i18n("sound"),
        func: () => {
          dispatch(
            toggleBGM({
              ...isBGMEnabled,
              enabled: !enabled,
            }),
          );
        },
        border: true,
        iconColor: "#88919A",
        hidden: WEB_LAYOUT === "v2",
      },
      {
        icon: GrAnnounce,
        text: i18n("announcement"),
        link: "announcement",
        func: () => {
          setSearchParams({ announcement_open: "true" });
        },
        iconColor: "#88919A",
      },
    ],
  };

  return menu;
};
